import { z } from 'zod';

/**
 * Tradizioni Sacre del Chierico (DRAFT-V0-20251016).
 *
 * Una "Tradizione Sacra" è un raggruppamento di incantesimi entro la classe,
 * legato alla divinità venerata. Il giocatore ne sceglie UNA in fase di
 * creazione PG e quella scelta filtra il sotto-insieme di spell accessibili.
 *
 * - Druido: ha un'unica tradizione implicita ("della Natura"), non modellata
 *   come scelta perché è l'unica.
 * - Chierico: 5 tradizioni esplicite (vedi enum sotto).
 * - Mago, Warlock, Sciamano, Paladino: NON usano tradizioni in questa forma
 *   (Mago = Corpus Arcano libero, Warlock = concesse dal Patrono, Sciamano e
 *   Paladino da definire quando arriverà il manuale aggiornato).
 */
export const TradizioneSacraChiericoSchema = z.enum([
  'crepuscolo',
  'guarigione',
  'illuminazione',
  'negromanzia',
  'valore',
]);
export type TradizioneSacraChierico = z.infer<typeof TradizioneSacraChiericoSchema>;

export const TRADIZIONI_SACRE_CHIERICO = TradizioneSacraChiericoSchema.options;

/**
 * Tradizioni Sacre del Paladino (manuale classi, riga 3375).
 *
 * Il Paladino ha 3 Tradizioni Sacre:
 * - **Negromanzia**, **Valore**: sempre disponibili
 * - **Natura**: disponibile **solo se l'archetipo del Paladino è Elfo**
 *   (NON se il PG è di razza Elfo — la distinzione conta: razza e archetipo
 *   sono scelte indipendenti, il vincolo è sull'archetipo).
 *
 * Il vincolo Natura→archetipo Elfo è espresso a livello di {@link SpellAccess}
 * tramite il campo `requiresArchetype`.
 */
export const TradizioneSacraPaladinoSchema = z.enum(['negromanzia', 'valore', 'natura']);
export type TradizioneSacraPaladino = z.infer<typeof TradizioneSacraPaladinoSchema>;

export const TRADIZIONI_SACRE_PALADINO = TradizioneSacraPaladinoSchema.options;
